module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/194-malta-629ceda848df223d1cf50fd66478d730.svg";